import { render, staticRenderFns } from "./PrevueBoard.vue?vue&type=template&id=512799f6&"
import script from "./PrevueBoard.vue?vue&type=script&lang=ts&"
export * from "./PrevueBoard.vue?vue&type=script&lang=ts&"
import style0 from "./PrevueBoard.vue?vue&type=style&index=0&id=512799f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports